/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Article } from './Article'
import { ArticleFromJSON, ArticleFromJSONTyped, ArticleToJSON } from './Article'
import type { Author } from './Author'
import { AuthorFromJSON, AuthorFromJSONTyped, AuthorToJSON } from './Author'
import type { ContentInner } from './ContentInner'
import {
  ContentInnerFromJSON,
  ContentInnerFromJSONTyped,
  ContentInnerToJSON,
} from './ContentInner'
import type { Image } from './Image'
import { ImageFromJSON, ImageFromJSONTyped, ImageToJSON } from './Image'

/**
 *
 * @export
 * @interface ArticlePageData
 */
export interface ArticlePageData {
  /**
   *
   * @type {string}
   * @memberof ArticlePageData
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ArticlePageData
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ArticlePageData
   */
  category: string
  /**
   *
   * @type {string}
   * @memberof ArticlePageData
   */
  publishedAt: string
  /**
   *
   * @type {string}
   * @memberof ArticlePageData
   */
  readingTime: string
  /**
   *
   * @type {Array<Image>}
   * @memberof ArticlePageData
   */
  thumbnail: Array<Image>
  /**
   *
   * @type {Author}
   * @memberof ArticlePageData
   */
  author: Author
  /**
   *
   * @type {Array<ContentInner>}
   * @memberof ArticlePageData
   */
  constructor: Array<ContentInner>
  /**
   *
   * @type {Array<Article>}
   * @memberof ArticlePageData
   */
  relevantPosts: Array<Article>
}

/**
 * Check if a given object implements the ArticlePageData interface.
 */
export function instanceOfArticlePageData(
  value: object
): value is ArticlePageData {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  if (!('category' in value) || value['category'] === undefined) return false
  if (!('publishedAt' in value) || value['publishedAt'] === undefined)
    return false
  if (!('readingTime' in value) || value['readingTime'] === undefined)
    return false
  if (!('thumbnail' in value) || value['thumbnail'] === undefined) return false
  if (!('author' in value) || value['author'] === undefined) return false
  if (!('constructor' in value) || value['constructor'] === undefined)
    return false
  if (!('relevantPosts' in value) || value['relevantPosts'] === undefined)
    return false
  return true
}

export function ArticlePageDataFromJSON(json: any): ArticlePageData {
  return ArticlePageDataFromJSONTyped(json, false)
}

export function ArticlePageDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ArticlePageData {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    category: json['category'],
    publishedAt: json['publishedAt'],
    readingTime: json['readingTime'],
    thumbnail: (json['thumbnail'] as Array<any>).map(ImageFromJSON),
    author: AuthorFromJSON(json['author']),
    constructor: (json['constructor'] as Array<any>).map(ContentInnerFromJSON),
    relevantPosts: (json['relevantPosts'] as Array<any>).map(ArticleFromJSON),
  }
}

export function ArticlePageDataToJSON(value?: ArticlePageData | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    category: value['category'],
    publishedAt: value['publishedAt'],
    readingTime: value['readingTime'],
    thumbnail: (value['thumbnail'] as Array<any>).map(ImageToJSON),
    author: AuthorToJSON(value['author']),
    constructor: (value['constructor'] as Array<any>).map(ContentInnerToJSON),
    relevantPosts: (value['relevantPosts'] as Array<any>).map(ArticleToJSON),
  }
}
